import { render, staticRenderFns } from "./componentNavigation.vue?vue&type=template&id=2e8369e0&scoped=true&"
import script from "./componentNavigation.vue?vue&type=script&lang=js&"
export * from "./componentNavigation.vue?vue&type=script&lang=js&"
import style0 from "./componentNavigation.vue?vue&type=style&index=0&id=2e8369e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8369e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VIcon,VRow,VSheet})
